module.exports = __webpack_public_path__ + "assets/038a5fe04875135fb5a74b1e13453d3c.svg";